var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserPic = function SvgUserPic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "301.000000pt",
    height: "301.000000pt",
    viewBox: "0 0 301.000000 301.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,301.000000) scale(0.100000,-0.100000)",
    fill: "#275f8e",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1420 3004 c-286 -23 -517 -101 -745 -248 -442 -287 -709 -831 -666 -1358 22 -259 86 -458 223 -686 l50 -83 55 60 c110 122 302 242 496 310 l89 31 46 -41 c72 -63 185 -129 280 -163 83 -29 94 -31 242 -31 148 0 159 1 242 31 95 34 208 100 280 163 l46 41 89 -31 c198 -70 384 -187 504 -317 l61 -67 22 28 c37 49 125 208 155 282 129 310 150 676 56 1000 -164 563 -649 985 -1225 1064 -91 12 -239 20 -300 15z m214 -500 c232 -59 421 -257 497 -519 20 -68 23 -103 24 -230 0 -200 -31 -315 -124 -457 -148 -227 -382 -344 -620 -309 -144 21 -241 70 -354 180 -167 160 -248 380 -234 634 7 130 30 218 86 332 90 182 242 313 426 366 77 23 218 24 299 3z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserPic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/userPic.d0cc4559.svg";
export { ForwardRef as ReactComponent };